// Feature flags per organization, for the organization filter. IoT.API
// answers a targeted flag only for the customer it is asked about, so they are
// loaded once per organization at sign-in, before the filter is turned on (its
// own flag is per organization). state.appConfigurations then holds the merged
// flags of the current scope: see applyScopedAppConfigurations.
import api from "services/backendService";
import { mergeOrganizationFlags, toFlagMap } from "contexts/orgFilter";
import { SET_APP_CONFIGURATIONS } from "./appConfigurations";

export const SET_ORGANIZATION_APP_CONFIGURATIONS = "SET_ORGANIZATION_APP_CONFIGURATIONS";

const initialState = { byOrg: {}, failedOrgGuids: [], isLoaded: false };

const organizationAppConfigurations = (state = initialState, action) =>
  action.type === SET_ORGANIZATION_APP_CONFIGURATIONS
    ? { ...state, ...action.payload, isLoaded: true }
    : state;

export default organizationAppConfigurations;

// A failed organization counts as "every flag off" and is listed in
// failedOrgGuids. The API answers [] on a non-200 and always lists every flag
// otherwise, so an empty answer is a failure too.
//
// `loaded`: flags already read (byOrg), kept rather than asked again, so a
// later load (a new organization) costs one request per new organization. A
// failed one is not in it and is asked again; one not in `orgGuids` is dropped.
export const loadOrganizationAppConfigurationsAsync = async (dispatch, orgGuids = [], loaded = {}) => {
  const toLoad = orgGuids.filter((guid) => !loaded[guid]);
  const results = await Promise.allSettled(
    toLoad.map((guid) => api.getAppConfigurationsAsync(null, guid, true))
  );
  const byOrg = Object.fromEntries(
    orgGuids.filter((guid) => loaded[guid]).map((guid) => [guid, loaded[guid]])
  );
  const failedOrgGuids = [];
  results.forEach((result, index) => {
    const answered = result.status === "fulfilled" && Array.isArray(result.value) && result.value.length > 0;
    if (answered) byOrg[toLoad[index]] = toFlagMap(result.value);
    else failedOrgGuids.push(toLoad[index]);
  });
  const payload = { byOrg, failedOrgGuids };
  dispatch({ type: SET_ORGANIZATION_APP_CONFIGURATIONS, payload });
  return payload;
};

// No request: the filtered organization's flags, or "on for any" with no filter.
export const applyScopedAppConfigurations = (dispatch, byOrg, scopeOrgGuids) => {
  const payload = mergeOrganizationFlags(byOrg, scopeOrgGuids);
  dispatch({ type: SET_APP_CONFIGURATIONS, payload });
  return payload;
};
